module.exports = __webpack_public_path__ + "img/passwords.79d8a31a.png";